export function getStatusColor(status: string): string {
  switch (status) {
    case "มีการส่งโปรให้ทางแชทแล้ว":
      return "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900 dark:text-blue-200 dark:border-blue-800";
    case "ลูกค้ากำลังพิจารณา":
      return "bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900 dark:text-yellow-200 dark:border-yellow-800";
    case "มีการโอนจอง":
      return "bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-900 dark:text-purple-200 dark:border-purple-800";
    case "ปิดการขายสำเร็จ(จ่ายเต็ม)":
      return "bg-green-100 text-green-800 border-green-200 dark:bg-green-900 dark:text-green-200 dark:border-green-800";
    case "ปิดการขายไม่สำเร็จ":
      return "bg-red-100 text-red-800 border-red-200 dark:bg-red-900 dark:text-red-200 dark:border-red-800";
    case "OPเเจ้งชั่วโมงผปคแล้ว":
      return "bg-teal-100 text-teal-800 border-teal-200 dark:bg-teal-900 dark:text-teal-200 dark:border-teal-800";
    default:
      return "bg-muted text-muted-foreground";
  }
}
